import { useEffect, useState } from "react";
import { FeatureType } from "../type";
import { Button, Modal, Popconfirm } from "antd";
import EditFeatureModal from "./editFeatureModal";
import deleteFeature from "../function/deleteFeature";
import { toast } from "react-toastify";

interface FeatureItemsProps {
    feature: FeatureType;
    setTriggerReload: React.Dispatch<React.SetStateAction<number>>;
}

const FeatureItems = ({ feature , setTriggerReload }: FeatureItemsProps) => {
    const [editModal, setEditModal] = useState(false);

    const [featureData, setFeatureData] = useState<FeatureType>(feature);

    useEffect(() => {
        setFeatureData(feature);
    }, [feature]);

    function confirmDelete() {
        deleteFeature(feature.id);
        setTriggerReload(prev => prev + 1);
        toast.success("Feature deleted successfully");
    }

    return (
        <div className="border p-4 flex flex-col rounded-lg gap-2">
            <Modal
                open={editModal}
                width={800}
                title="Edit Feature"
                footer={null}
                onCancel={() => setEditModal(false)} >
                <EditFeatureModal
                    featureId={feature.id}
                    onClose={() => {
                        setTriggerReload(prev => prev + 1);
                        setEditModal(false);
                    }} />
            </Modal>
            <div className="flex flex-row gap-4 items-start justify-between w-full">
                <div>
                    <h3 className="font-semibold text-lg">{feature.name}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                </div>
                <div className="flex flex-row gap-2">
                    <button
                        onClick={() => setEditModal(true)}
                        className="px-4 py-2 rounded-lg bg-blue-600 !text-white hover:bg-blue-700 transition-colors">
                        Edit
                    </button>
                    <Popconfirm
                        title="Delete the Feature"
                        description="Are you sure to delete this feature?"
                        placement="topRight"
                        onConfirm={confirmDelete}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button className="ml-2 px-4 py-2 rounded-lg !bg-red-600 !text-white hover:bg-red-700 transition-colors">
                            Delete
                        </Button>
                    </Popconfirm>
                </div>
            </div>
            <div className="flex flex-col gap-1">
                {feature.key && <p className="text-sm text-gray-500">Key: {feature.key}</p>}
                {feature.number !== null && <p className="text-sm text-gray-500">Value: {feature.number}</p>}
            </div>
        </div>
    );
}

export default FeatureItems;